// News Letter Modal Functionality
class NewsLetterModal {
  constructor() {
    this.modal = document.querySelector('.news-letter-modal');
    this.container = this.modal?.querySelector('.news-letter-modal-container');
    this.successContainer = this.modal?.querySelector('.news-letter-modal-success');
    this.closeBtn = this.modal?.querySelector('.news-letter-modal-right-header button');
    this.leftCloseBtn = this.modal?.querySelector('.news-letter-modal-left-header button');
    this.successCloseBtn = this.modal?.querySelector('.news-letter-modal-success-header-button');
    this.subscribeBtn = this.modal?.querySelector('.news-letter-modal-right-form button');
    this.browseBtn = this.modal?.querySelector('.news-letter-modal-success-button');
    
    this.init();
  }
  
  init() {
    if (!this.modal) return;
    
    // Initially hide success container
    this.hideSuccess();
    
    // Close button events
    this.closeBtn?.addEventListener('click', () => this.close());
    this.successCloseBtn?.addEventListener('click', () => this.close());
    this.leftCloseBtn?.addEventListener('click', () =>  this.close());
    // Subscribe button event
    this.subscribeBtn?.addEventListener('click', (e) => this.handleSubscribe(e));
    
    // Browse products button event
    this.browseBtn?.addEventListener('click', () => this.close());
    
    // TODO: Implement click outside modal to close
    // Add event listener to modal background to close when clicking outside container
    this.modal?.addEventListener('click', (e) => {
      // Check if click is outside the container and success container
      if (e.target === this.modal) {
        this.close();
      }
    });
    
    // Escape key event
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen()) {
        this.close();
      }
    });
    
    // Auto-open after delay (only once)
    this.autoOpen();
  }
  
  open() {
    if (!this.modal) return;

    
    this.modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    
    // Show container, hide success initially
    this.showContainer();
    this.hideSuccess();
    
    // Focus management
    this.modal.focus();
    
    // Trigger custom event
    document.dispatchEvent(new CustomEvent('newsLetterModalOpened'));
  }
  
  close() {
    if (!this.modal) return;
    
    this.modal.classList.remove('is-open');
    document.body.style.overflow = '';
    
    // Reset to initial state
    this.showContainer();
    this.hideSuccess();
    
    // Trigger custom event
    document.dispatchEvent(new CustomEvent('newsLetterModalClosed'));
  }
  
  isOpen() {
    return this.modal?.classList.contains('is-open');
  }
  
  showContainer() {
    if (this.container) {
      this.container.style.display = 'flex';
    }
  }
  
  hideContainer() {
    if (this.container) {
      this.container.style.display = 'none';
    }
  }
  
  showSuccess() {
    if (this.successContainer) {
      this.successContainer.style.display = 'block';
    }
  }
  
  hideSuccess() {
    if (this.successContainer) {
      this.successContainer.style.display = 'none';
    }
  }
  
  async handleSubscribe(e) {
    e.preventDefault();
    e.stopPropagation();

    const form = e.target.closest('form');
    const formData = new FormData(form);
 
    try {
      const submitFormResponse = await fetch(`https://manage.kmail-lists.com/ajax/subscriptions/subscribe`, {
        method: 'POST',
        body: formData,
      });

      if (!submitFormResponse.ok) {
        throw new Error(`HTTP error! status: ${submitFormResponse.status}`);
      }

      const submitFormResponseData = await submitFormResponse.json();
      const { data, errors, success } = submitFormResponseData;

      if(errors.length > 0){
        errors.forEach(error => {
          console.error(error);
        });

        return
      }

      // Handle success
      this.showSuccessState();
    } catch (error) {
      console.error('Error submitting to Klaviyo:', error);
      // Handle error - show error message to user
    }
   
  }
  
  showSuccessState() {
    // Hide the form container
    this.hideContainer();
    
    // Show the success container
    this.showSuccess();
  }
  
  autoOpen() {
      // Auto-open modal after 3 seconds (only if not shown today)
    setTimeout(() => {
      if(!this.hasBeenShownToday()){
        this.open();
        this.markAsShown();
      }
    }, 3000);
  }
  
  hasBeenShownToday() {
    const lastShown = localStorage.getItem('newsLetterModalLastShown');
    if (!lastShown) return false;
    
    const lastShownDate = new Date(lastShown);
    const now = new Date();
    
    // Check if it was shown today (same day)
    const lastShownDay = lastShownDate.toDateString();
    const today = now.toDateString();
    
    return lastShownDay === today;
  }
  
  markAsShown() {
    localStorage.setItem('newsLetterModalLastShown', new Date().toISOString());
  }
  
  // Method to open modal from external triggers
  static open() {
    const modal = new NewsLetterModal();
    modal.open();
  }
  
  // Method to reset modal state (useful for testing)
  static reset() {
    localStorage.removeItem('newsLetterModalLastShown');
  }
  
  // Method to check if modal can be shown today (useful for debugging)
  static canShowToday() {
    const lastShown = localStorage.getItem('newsLetterModalLastShown');
    if (!lastShown) return true;
    
    const lastShownDate = new Date(lastShown);
    const now = new Date();
    
    const lastShownDay = lastShownDate.toDateString();
    const today = now.toDateString();
    
    return lastShownDay !== today;
  }
}

// Initialize modal when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new NewsLetterModal();
});

// Make modal globally accessible
window.NewsLetterModal = NewsLetterModal;
